import { devtools } from "zustand/middleware"
import { create } from "zustand"
import { IEventStore, Idea } from "@proj-common/types"
import { InitialData } from "@proj-client/utils/initialData"
import { produce } from "immer"
import { SiteDeploymentType } from "@proj-common/utils"
import { getIdeasForStageStep } from "@proj-client/helpers/event-helper"

const updateCurrentIdeas = (state) => {
    let currentIdeas = getIdeasForStageStep(
        state.event.ideas,
        state.event.currentstage?.id,
        state.event.activestep?.id,
        state.event.activestage?.type,
        state.event.template
    );
    state.event.currentIdeas = currentIdeas;
    state.event.currentParticipantIdeas = currentIdeas.filter((idea) => idea.participant_id === state.event.participant.id);
};

export const useEventStore = create<IEventStore>()(
    devtools(
        (set) => {
            const state = {
                event: {
                    ideas: [],
                    currentIdeas: [],
                    currentParticipantIdeas: [],
                    ...InitialData.EventStore?.event,
                },
            };

            updateCurrentIdeas(state);

            return {
                event: state.event,
                setParticipants: (participants, participant) =>
                    set(
                        produce((state) => {
                            state.event.participant = participant;
                            state.event.participants = participants;
                        })
                    ),
                setIdeas: (ideas) =>
                    set(
                        produce((state) => {
                            state.event.ideas = ideas
                            updateCurrentIdeas(state)
                        })
                    ),
                setStageStepActions: (stage_step_actions) =>
                    set(
                        produce((state) => {
                            console.log(`📊 setting stage step actions`, stage_step_actions)
                            // Create a new array with updated ideas to trigger Zustand's shallow comparison
                            state.event.ideas = state.event.ideas.map((idea: Idea) => {
                                const newIdea = { ...idea }
                                newIdea.stage_step_actions = stage_step_actions.filter((ssa) => ssa.idea_id === idea.idea_id)
                                return newIdea
                            })
                            updateCurrentIdeas(state)
                        })
                    ),
                setEventDetails: (event_details) =>
                    set(
                        produce((state) => {
                            state.event = {
                                ...state.event,
                                ...event_details,
                            };
                            updateCurrentIdeas(state);
                        })
                    ),
                setParticipantPings: (participantPings) =>
                    set(
                        produce((state) => ({
                            event: {
                                ...state.event,
                                participantPings,
                            },
                        }))
                    ),
                setParticipantPingServerTs: (participantPingServerTs) =>
                    set(
                        produce((state) => {
                            state.event.participantPingServerTs = participantPingServerTs;
                        })
                    ),

                toggleAreIdeasSortedByMostRecent: () =>
                    set(
                        produce((state) => {
                            state.event.areIdeasSortedByMostRecent = !state.event.areIdeasSortedByMostRecent;
                        })
                    ),
            };
        },
        { name: "Ideate Live", store: "EventStore", enabled: SiteDeploymentType() == "development" }
    )
);
